/**
 * TabCertyfikat — Zakładka "Pliki cert/klucz" — upload certyfikatu i klucza.
 *
 * Po refaktorze 2026-06-01: tylko cert+klucz (hasło przeniesione do osobnej
 * zakładki "Hasło klucza").
 *
 * Props:
 *   - adminConfig (object)
 *   - savedNip (string)
 *   - onSaved (callback)
 */
import { FileCheck } from "lucide-react";
import { CertFileForm } from "../components/CertFileForm";
import { KeyFileForm } from "../components/KeyFileForm";

export const TabCertyfikat = ({ adminConfig, savedNip, onSaved }) => {
  const needsNip = !savedNip;

  return (
    <div className="space-y-4" data-testid="tab-certyfikat">
      {needsNip ? (
        <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-sm text-yellow-800 font-medium">Najpierw zapisz NIP podmiotu</p>
          <p className="text-xs text-yellow-700 mt-1">
            Przejdź do zakładki "Podmiot" i zapisz NIP — jest wymagany do wgrania certyfikatu.
          </p>
        </div>
      ) : (
        <>
          <div className="mb-2">
            <div className="flex items-center gap-2 mb-1">
              <FileCheck className="w-4 h-4 text-gray-500" />
              <h3 className="text-sm font-semibold text-gray-700">Pliki certyfikatu KSeF</h3>
            </div>
            <p className="text-xs text-gray-500">
              Wgraj certyfikat typu <strong>Uwierzytelnienie (do API)</strong> pobrany z portalu KSeF.
              Nie używaj certyfikatów do podpisu linku/QR. Klucz prywatny w osobnym pliku.
            </p>
          </div>

          <CertFileForm adminConfig={adminConfig} onSaved={onSaved} />
          <KeyFileForm adminConfig={adminConfig} onSaved={onSaved} />

          <p className="text-xs text-gray-500 mt-2">
            Po wgraniu cert + klucza, przejdź do zakładki <strong>"Hasło klucza"</strong>{" "}
            aby ustawić hasło. Bez hasła nie da się pobrać faktur z KSeF.
          </p>
        </>
      )}
    </div>
  );
};

export default TabCertyfikat;
